import React from 'react';

export const SavedProductsContext = React.createContext();

export default SavedProductsContext;